(function () {
  "use strict";
  var C = window.STORE_CONFIG, P = C.policies || {};
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var links = [].slice.call(document.querySelectorAll("[data-policy-open]"));
  var KEYS = { shipping: "shipping", returns: "returns", privacy: "privacy", terms: "terms", support: "contact" };
  var published = function (key) { return !!P.modalsEnabled && !!(P.publish || {})[KEYS[key]]; };
  function placeholder(a) {
    a.addEventListener("click", function (e) { e.preventDefault(); var t = $("policy-text"); if (t) t.textContent = "This policy is not published yet. Questions: " + (C.supportEmail || ""); });
  }
  if (!links.some(function (a) { return published(a.dataset.policyOpen); })) { links.forEach(placeholder); return; }
  var content = null, pending = null, lastTrigger = null, modal, dialog, body, titleEl;

  function load(cb) {
    if (content) return cb();
    if (pending) return pending.push(cb);
    pending = [cb];
    var s = document.createElement("script");
    s.src = window.GS_POLICIES;
    s.onload = function () { content = window.STORE_POLICIES || {}; var q = pending; pending = null; q.forEach(function (fn) { fn(); }); };
    s.onerror = function () { pending = null; };
    document.head.appendChild(s);
  }

  var LINKS = /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})|(https?:\/\/[^\s)]+[^\s).,])/gi;
  function linkify(t) {
    var out = "", last = 0, m;
    LINKS.lastIndex = 0;
    while ((m = LINKS.exec(t))) {
      out += esc(t.slice(last, m.index));
      out += m[1] ? '<a href="mailto:' + esc(m[1]) + '">' + esc(m[1]) + "</a>" : '<a href="' + esc(m[2]) + '" target="_blank" rel="noopener noreferrer">' + esc(m[2]) + "</a>";
      last = m.index + m[0].length;
    }
    return out + esc(t.slice(last));
  }
  function render(doc) {
    return doc.blocks.map(function (b) {
      if (b.type === "h") return "<h3>" + linkify(b.text) + "</h3>";
      if (b.type === "ul") return "<ul>" + b.items.map(function (i) { return "<li>" + linkify(i) + "</li>"; }).join("") + "</ul>";
      return "<p>" + linkify(b.text) + "</p>";
    }).join("");
  }

  function build() {
    modal = document.createElement("div");
    modal.className = "pm"; modal.id = "policy-modal"; modal.hidden = true;
    modal.innerHTML =
      '<div class="pm-backdrop" data-pm-close></div>' +
      '<div class="pm-dialog" role="dialog" aria-modal="true" aria-labelledby="pm-title" tabindex="-1">' +
        '<header class="pm-head"><h2 class="pm-title" id="pm-title"></h2>' +
          '<button type="button" class="pm-close" data-pm-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></header>' +
        '<p class="pm-draft" hidden>DRAFT: this policy text has not been approved by the store owner yet.</p>' +
        '<div class="pm-body" id="pm-body" tabindex="0" role="document"></div>' +
      "</div>";
    document.body.appendChild(modal);
    dialog = modal.querySelector(".pm-dialog"); body = modal.querySelector(".pm-body"); titleEl = modal.querySelector(".pm-title");
    modal.addEventListener("click", function (e) { if (e.target.closest && e.target.closest("[data-pm-close]")) close(); });
    modal.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key !== "Tab") return;
      var f = [].slice.call(dialog.querySelectorAll('a[href], button, [tabindex="0"]')).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });
  }

  var inerted = [];
  function open(key, trigger) {
    load(function () {
      var doc = content[KEYS[key]];
      if (!doc) return;
      if (!modal) build();
      lastTrigger = trigger || document.activeElement;
      titleEl.textContent = doc.title;
      modal.querySelector(".pm-draft").hidden = doc.ownerApproved === true;
      body.innerHTML = render(doc);
      modal.dataset.policy = KEYS[key];
      modal.hidden = false;
      body.scrollTop = 0;
      document.documentElement.classList.add("pm-open");
      inerted = [].slice.call(document.body.children).filter(function (el) { return el !== modal && !el.inert; });
      inerted.forEach(function (el) { el.inert = true; });
      modal.querySelector(".pm-close").focus();
    });
  }
  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove("pm-open");
    inerted.forEach(function (el) { el.inert = false; }); inerted = [];
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  links.forEach(function (a) {
    if (!published(a.dataset.policyOpen)) return placeholder(a);
    a.setAttribute("aria-haspopup", "dialog");
    a.addEventListener("click", function (e) { e.preventDefault(); open(a.dataset.policyOpen, a); });
  });
  window.StorePolicies = { open: open, close: close };
})();
